"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

var _util = require("../../util");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  50% {opacity: 1;}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  from { transform: scale(1);},\n  to {transform: scale(1.4);}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var pulse = (0, _react.keyframes)(_templateObject());
var blink = (0, _react.keyframes)(_templateObject2());

var avatarBase = function avatarBase(theme) {
  return /*#__PURE__*/(0, _react.css)("background:100% 100%/cover no-repeat;display:flex;justify-content:center;align-items:center;width:", (0, _util.rem)(32), ";height:100%;border-right:1px solid rgba(", theme.color.monochrome.white_rgba, ", 0.15);background-color:inherit;color:inherit;" + (process.env.NODE_ENV === "production" ? "" : ";label:avatarBase;"));
};

var bigAvatar = function bigAvatar(theme) {
  return /*#__PURE__*/(0, _react.css)(avatarBase(theme), ";width:", (0, _util.rem)(32), ";height:", (0, _util.rem)(32), ";margin-right:", (0, _util.rem)(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bigAvatar;"));
};

var smallAvatar = function smallAvatar(theme) {
  return /*#__PURE__*/(0, _react.css)(avatarBase(theme), ";width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";border-radius:50%;margin-right:", (0, _util.rem)(4), ";font-size:", theme.fontSize.tiny, ";border-right:none;color:", theme.color.monochrome.white, ";background-color:", theme.color.primary.positive, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:smallAvatar;"));
};

var dotStyle = /*#__PURE__*/(0, _react.css)("width:2px;height:2px;background-color:currentColor;margin:0 1px;border-radius:50%;opacity:0.4;animation:", pulse, " 2s ease-out infinite;" + (process.env.NODE_ENV === "production" ? "" : ";label:dotStyle;"));
var dot = /*#__PURE__*/(0, _react.css)("display:flex;margin-left:", (0, _util.rem)(8), ";&>span,&::before,&::after{", dotStyle, ";}&>span{animation:", blink, " 1s infinite 0.6666s;}&::before{content:'';animation:", blink, " 1s infinite 0.3333s;}&::after{content:'';animation:", blink, " 1s infinite 0.9999s;}" + (process.env.NODE_ENV === "production" ? "" : ";label:dot;"));

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:inline-flex;align-items:center;line-height:", theme.lineHeight.leadingNormal, ";border-radius:6px;padding-right:", theme.spacing[7], ";overflow:hidden;font-weight:", theme.fontWeight.medium, ";font-size:", theme.fontSize.base, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var secondarySmall = function secondarySmall(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.warningText, ";&>div:first-of-type{background-color:", theme.color.primary.warning, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:secondarySmall;"));
};

var small = function small(theme, type) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";color:", theme.color.primary.positive, ";font-size:", theme.fontSize.xsmall, ";background-color:transparent;", type === 'secondary' && secondarySmall(theme), ";&>span:last-of-type{margin-left:4px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var primary = function primary(theme, size) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";color:", theme.color.monochrome.white, ";background-color:", theme.color.primary.positive, ";", size === 'small' && small(theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:primary;"));
};

var secondary = function secondary(theme, size) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";color:", theme.color.monochrome.black, ";background-color:", theme.color.primary.warning, ";", size === 'small' && small(theme, 'secondary'), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:secondary;"));
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "9n72uu",
  styles: "&>div:first-of-type{border-right:none;}"
} : {
  name: "1btx846-detection",
  styles: "&>div:first-of-type{border-right:none;};label:detection;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var detection = function detection(_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type,
      size = _ref2.size,
      hasAvatar = _ref2.hasAvatar;
  return /*#__PURE__*/(0, _react.css)(base(theme), ";", type === 'primary' && primary(theme, size), ";", type === 'secondary' && secondary(theme, size), ";", hasAvatar && _ref, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:detection;"));
};

var styles = {
  detection: detection,
  primary: primary,
  secondary: secondary,
  bigAvatar: bigAvatar,
  smallAvatar: smallAvatar,
  dot: dot
};
exports.styles = styles;
//# sourceMappingURL=Detection.styles.js.map